//
// View.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../BIRDModel";
import "./Header";
import "./Section";
import "./PageSetup";
import "@sas-dvr/ltjs-commons/util/Dimension";

var View = createModule("BIRD::View", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        pageSetup: 1,
        fixedBodyHeight: 1,
        representativeVisual: 1,
        fixedBodyWidth: 1,
        header: 1,
        sections: [1],
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default View;
